<template>
  <v-row class="ma-0">
    <div v-if="validationErrors" class="errorValidation">
      <ul class="alert alert-danger">
        <li v-for="(value, key, index) in validationErrors">{{$t('errorValidations.'+(value.replace(/ /g, "_")).slice(0, -1))}}</li>
      </ul>
    </div>
  </v-row>
</template>


<script>
  export default {
    data() {
      return {
      }
    },
    props: {
      errors: null,
    },
    computed: {
      validationErrors() {
        let errors = Object.values(this.errors);
        errors = errors.flat();
        return errors;
      }
    }
  }
</script>

<style>
  .alert {
    border: 2px solid #ff6a4a;
    background-color: rgba(255, 140, 0, 0.37);
    text-align: left;
  }

  .alert li {
    color: red;
  }

  .errorValidation {
    min-width: 100%;
    margin: 0 !important;
  }
</style>
